module.exports = THD_OVERLAY;